import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPhone16a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02 11.866 4.134 6.98l2.094-2.093a.988.988 0 0 0 0-1.397C5.062 2.327 3.901 1.163 2.737 0L.285 2.455A.952.952 0 0 0 0 3.15c.093 3.51 1.474 6.753 3.785 9.064C6.101 14.529 9.35 15.907 12.85 16a.952.952 0 0 0 .696-.284L16 13.262l-3.49-3.49a.988.988 0 0 0-1.396 0L9.02 11.866Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPhone16a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconPhone16 = createIcon(IconComponent);